// it is user data for user "All"
const userAll = {
    id: null,
    name: 'LABEL.ALL',
    last_name: 'LABEL.ALL.ADVISORS',
    color: '#27DBBD - #DF2E17', // "#27DBBD - #DF2E17"
};
const userAllDisabled = {
    id: null,
    disabled: true,
    name: 'LABEL.ALL',
    last_name: 'LABEL.ALL.ADVISORS',
    color: '#828282 - #8С8С8С',
};
export { userAll, userAllDisabled, };
